<template>
  <div>
    <v-divider v-if="$vuetify.display.mdAndUp || index > 0"/>
    <v-list-item
        class="px-0"
    >
      <v-row>
        <v-col
            order="3"
            order-md="1"
            cols="5"
            md="2"
            class="text-end text-md-center"
            align-self="center"
        >
          <p class="text-subtitle-1 text-md-center">{{ date }}</p>
        </v-col>
        <v-col
            order="1"
            order-md="3"
            cols="1"
            md="3"
            class="text-md-center"
            align-self="center"
        >
          <p
              v-if="$vuetify.display.mdAndUp"
              class="text-subtitle-1 text-center"
          >
            {{ type }}
          </p>
          <v-icon
              v-if="$vuetify.display.smAndDown"
              :icon="type === 'Credit' ? 'mdi-database-plus' : 'mdi-database-minus'"
              :color="type === 'Credit' ? 'green' : 'red'"
          />
        </v-col>
        <v-col
            order="2"
            order-md="5"
            cols="6"
            md="2"
            class="text-md-center pl-5"
            align-self="center"
        >
          <p class="text-md-subtitle-1 text-h6  text-md-center">{{ amount }}</p>
        </v-col>
        <v-col
            order="4"
            order-md="7"
            md="5"
            class="pt-0 pb-4 py-md-3"
        >
          <p class="text-subtitle-1">{{ description }}</p>
        </v-col>
      </v-row>
    </v-list-item>
  </div>
</template>

<script>

export default {
  name: "PaymentListItem",
  props: {
    index: Number,
    date: String,
    type: String,
    amount: String,
    description: String
  }
}
</script>

<style scoped>

</style>